import { render, staticRenderFns } from "./contentTagRecycle.vue?vue&type=template&id=cab50b06&"
import script from "./contentTagRecycle.vue?vue&type=script&lang=js&"
export * from "./contentTagRecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports